import {ActionFunctionContext} from 'notebook/structured-tables/action-functions/ActionFunctionContext';
import downloadStructuredTableCSV, {
  getStructuredTableCSVDownloadDisabledReason,
} from 'notebook/structured-tables/util/downloadStructuredTableCSV';
import * as DownloadAsCSVDAO from 'notebook/tables/export/DownloadAsCSVDAO';

import {UnknownStructuredTable, UnknownStructuredTableAdapter} from '../StructuredTableConstants';
import makeSimpleActionFunction from './makeSimpleActionFunction';

/**
 * An ActionFunction that prepares a CSV export to download of a
 * StructuredTable from within the browser.
 */
export const downloadCSVActionFunction = makeSimpleActionFunction({
  label: 'Download as CSV',
  icon: 'download',
  onInvoke: async ({
    structuredTable,
    structuredTableAdapter,
    computedTable,
    liveRowMetadataByRow,
    actionFunctionContext,
    entryOrTemplateId,
  }) => {
    await downloadStructuredTableCSV({
      structuredTable,
      structuredTableAdapter,
      computedTable,
      liveRowMetadataByRow,
    });
    auditDownloadTableAsCSV(
      structuredTable,
      structuredTableAdapter,
      entryOrTemplateId,
      actionFunctionContext
    );
  },
  getDisabled: ({structuredTable, computedTable}) =>
    getStructuredTableCSVDownloadDisabledReason({structuredTable, computedTable}) != null,
});

function auditDownloadTableAsCSV(
  structuredTable: UnknownStructuredTable,
  structuredTableAdapter: UnknownStructuredTableAdapter,
  documentLikeId: string | undefined | null,
  actionFunctionContext: ActionFunctionContext
): void {
  const parentAuditIds: Array<string> = [];
  // Add the potential parent audit ids
  if (documentLikeId) {
    parentAuditIds.push(documentLikeId);
  }
  if (actionFunctionContext.procedureMethodDefinitionVersionId) {
    parentAuditIds.push(actionFunctionContext.procedureMethodDefinitionVersionId);
  }
  if (actionFunctionContext.procedureId) {
    parentAuditIds.push(actionFunctionContext.procedureId);
  }
  // If there are no auditable parents, don't record an event as it won't be even show up anywhere.
  if (!parentAuditIds.length) {
    return;
  }
  DownloadAsCSVDAO.auditDownloadTableAsCSV({
    tableName: structuredTable.name || structuredTableAdapter.getDisplayName(structuredTable),
    structuredTableProvenanceUuid: structuredTable.provenanceUuid,
    documentLikeId: documentLikeId ?? undefined,
    parentAuditIds,
  });
}
